import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { IconName } from '../icon/icon-data.generated';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-empty-state',
  imports: [MatButtonModule, IconComponent],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  @Input({ required: true }) iconName!: IconName;
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() hint?: string;

  /**
   * Optional recovery action, e.g. "Show last 12 months" on a date-filtered list.
   *
   * The button renders only when a label is supplied, so every existing caller is unaffected. Mirrors
   * `app-error-state`'s retry affordance — same `.primary-btn` and the same centred action row — so a
   * patient meets one button shape whether the list is empty or the read failed.
   */
  @Input() actionLabel?: string;

  @Input() actionIcon: IconName = 'history';

  @Output() action = new EventEmitter<void>();
}
